(function ( $ ) {
 
    $.fn.inputMaterial = function() {
        return $.each(this, function() {
			checkFill($(this));
		
			$(this).on('change', function() {
				checkFill($(this));
			});
		});

		function checkFill($obj) {
			var val = $obj.val().trim();
		
			if(val) {
				val = val.trim();
			}
		
			if(!val || val.length === 0) {
				$obj.addClass('is-empty').removeClass('has-value');
			}
			else { 
				$obj.removeClass('is-empty').addClass('has-value');
			}
		}
    };
 
}( jQuery ));
